import { render, staticRenderFns } from "./QuickChatListPopup.vue?vue&type=template&id=5ee4f8bc&scoped=true&"
import script from "./QuickChatListPopup.vue?vue&type=script&lang=ts&"
export * from "./QuickChatListPopup.vue?vue&type=script&lang=ts&"
import style0 from "./QuickChatListPopup.vue?vue&type=style&index=0&id=5ee4f8bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4f8bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VList,VListItem,VListItemContent})
